import React, { useContext } from 'react';

import { LIGHT_MAIN_COLOR, PRIMARY_BLACK_COLOR } from '@constants/colors';

import Button from '@uikit/Form/Button/Button';
import { SVGIcon } from '@uikit/old/Icon/Icon';

import { HeaderFiltersButtonWithTooltipContext } from '@uikit/old/PageHeader/HeaderFiltersButtonWithTooltip/HeaderFiltersButtonWithTooltip';

const FiltersTooltipContentFooter = ({
  onAddFilterInput,
  onApplyFilters,
  addTestId,
  applyTestId,
}: {
  onAddFilterInput: () => void;
  onApplyFilters: () => void;
  addTestId?: string;
  applyTestId?: string;
}): JSX.Element => {
  const { cb } = useContext(HeaderFiltersButtonWithTooltipContext);

  const handleClick = (event) => {
    onApplyFilters();
    // TODO: TOOLTIP dirty solution.
    //  ReactTooltip.hide should be used instead but it didn't work.
    // maybe in the new version of ReactTooltip it will be adjusted
    event.target.closest('.__react_component_tooltip').classList.remove('show');
    cb();
  };

  return (
    <div className="relationships-filters-tooltip-content__footer">
      <Button
        onClick={onAddFilterInput}
        className="relationships-filters-tooltip-content__btn-add-filter"
        size="l"
        type="black"
        data-testid={addTestId}
      >
        <SVGIcon icon="plusCircle" color={LIGHT_MAIN_COLOR} />
        Add new filter
      </Button>
      <Button
        onClick={handleClick}
        className="relationships-filters-tooltip-content__btn-apply-filters"
        size="l"
        type="white"
        data-testid={applyTestId}
      >
        <SVGIcon icon="arrowLeft" color={PRIMARY_BLACK_COLOR} />
        Apply filters
      </Button>
    </div>
  );
};

export default FiltersTooltipContentFooter;
